import { formatDistanceToNow, parseISO } from 'date-fns';

export function formatRelativeTime(isoString: string): string {
  return formatDistanceToNow(parseISO(isoString), { addSuffix: true });
}
